<template>
  <b-collapse :key="componentKey" class="panel">
    <!-- <div slot="trigger" class="panel-heading"><strong>Righe</strong></div> -->
    <div class="panel-block">
      <table class="table is-fullwidth is-narrow">
        <thead>
          <tr>
            <th>Tipologia</th>
            <th>Descrizione</th>
            <th>Qt.</th>
            <th>Prezzo base</th>
            <th>Prezzo finale</th>
            <th>Sconto</th>
            <th>Totale</th>
            <th>IVA</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, key) in formData" :key="line.id">
            <td>
              <b-field
                :message="showErrors[key]['product']"
                :type="showErrors[key]['product'] ? 'is-danger' : ''"
              >
                <b-select
                  :value="line.product"
                  size="is-small"
                  @input="setProduct(line, $event)"
                >
                  <option
                    v-for="p in products.results"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.code }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['description']"
                :type="showErrors[key]['description'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="line.description"
                  size="is-small"
                  @focus="modalEdit(line, 'description')"
                ></b-input>
              </b-field>
            </td>
            <td width="80">
              <b-field
                :message="showErrors[key]['amount']"
                :type="showErrors[key]['amount'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="line.amount"
                  size="is-small"
                  type="number"
                ></b-input>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['base_price']"
                :type="showErrors[key]['base_price'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="line.base_price"
                  size="is-small"
                  icon="euro-sign"
                ></b-input>
              </b-field>
            </td>
            <td width="150">
              <b-field
                :message="showErrors[key]['final_price']"
                :type="showErrors[key]['final_price'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="line.final_price"
                  size="is-small"
                  icon="euro-sign"
                ></b-input>
                <button
                  class="button is-small"
                  @click="magicCalculator(line, line.base_price)"
                >
                  <b-icon icon="magic" />
                </button>
              </b-field>
            </td>
            <td>
              <b-field>
                <b-input
                  disabled
                  size="is-small"
                  :value="
                    formatDifference(
                      line.base_price,
                      line.final_price,
                      line.amount
                    )
                  "
                ></b-input>
              </b-field>
            </td>
            <td>
              <b-field>
                <b-input
                  size="is-small"
                  :value="
                    money(line.final_price)
                      .multiply(line.amount)
                      .toFormat()
                  "
                  disabled
                ></b-input>
              </b-field>
            </td>
            <td width="100">
              <b-field
                :message="showErrors[key]['tax']"
                :type="showErrors[key]['tax'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="line.tax"
                  size="is-small"
                  icon="percent"
                ></b-input>
              </b-field>
            </td>
            <td>
              <button class="button is-small" @click="formData.splice(key, 1)">
                <b-icon icon="minus-circle" type="is-danger" />
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <b>{{ totals.base.toFormat() }}</b>
            </td>
            <td>
              <b>{{ totals.final.toFormat() }}</b>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="9">
              <div class="buttons">
                <button
                  class="button is-success is-small"
                  @click="
                    formData.push({
                      estimate: estimateId,
                      amount: 1,
                      base_price: '0.00',
                      final_price: '0.00',
                      description: '',
                      tax: 22
                    })
                  "
                >
                  <b-icon icon="plus"></b-icon>
                  <span>Aggiungi</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small"
                  @click="reset"
                >
                  <b-icon icon="undo"></b-icon>
                  <span>Annulla</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-primary is-small"
                  type="submit"
                  @click="submit()"
                >
                  <b-icon icon="save"></b-icon>
                  <span>Salva</span>
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </b-collapse>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import find from "lodash/find"
import { get, call } from "vuex-pathify"

import dateHelpers from "@/mixins/dateHelpers"
import DiscountCalculator from "@/components/DiscountCalculator"

export default {
  mixins: [dateHelpers],
  props: {
    estimateId: {
      type: Number,
      required: true
    },
    lines: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: cloneDeep(this.lines),
      errors: []
    }
  },
  computed: {
    products: get("products/products"),
    totals() {
      let baseTotal = this.money(0)
      let finalTotal = this.money(0)
      this.formData.forEach(line => {
        try {
          baseTotal = baseTotal.add(
            this.money(line.base_price).multiply(line.amount)
          )
          finalTotal = finalTotal.add(
            this.money(line.final_price).multiply(line.amount)
          )
        } catch (TypeError) {}
      })
      return { base: baseTotal, final: finalTotal }
    },
    formHasEdits() {
      return JSON.stringify(this.lines) != JSON.stringify(this.formData)
    },
    showErrors() {
      if (this.errors.length > 0) {
        return this.errors
      } else {
        let elements = []
        this.formData.forEach(() => {
          elements.push({})
        })
        return elements
      }
    }
  },
  mounted() {
    this.fetchProducts()
  },
  methods: {
    fetchProducts: call("products/all"),
    submitAction: call("estimateLines/update"),
    product(id) {
      return (
        find(this.products.results, { id }) || {
          price: "0.00",
          description: ""
        }
      )
    },
    setProduct(line, productId) {
      line.product = productId
      line.description = this.product(productId).description
      line.base_price = this.product(productId).price
      line.final_price = this.product(productId).price
    },
    magicCalculator(line, basePrice) {
      this.$modal.open({
        parent: this,
        component: DiscountCalculator,
        props: { price: basePrice },
        hasModalCard: true,
        events: {
          update: value => {
            line.final_price = value
          }
        }
      })
    },
    reset() {
      this.errors = []
      this.formData = cloneDeep(this.lines)
      this.componentKey += 1
    },
    async submit() {
      try {
        await this.submitAction({
          estimateId: this.estimateId,
          data: this.formData
        })
        this.reset()
        this.$toast.open({
          message: "Modificato con successo",
          type: "is-success"
        })
      } catch (response) {
        // show errors in form
        this.errors = response.data
      }
    }
  }
}
</script>
